<script>
import appConfig from '@src/app.config';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import ConfirmationModal from '@components/modals/confirmation-modal.vue';
import EndWorkoutModal from '@components/modals/end-workout-modal.vue';
import TipsModal from '@components/modals/tips-modal.vue';
import VideoPreviewModal from '@components/modals/video-preview-modal.vue';
import LogoutModal from '@components/modals/logout-modal.vue';
import HeightInputModal from '@components/modals/height-input-modal.vue';
import BirthdayInputModal from './components/modals/birthday-input-modal.vue';
import NameInputModal from './components/modals/name-input-modal.vue';
import EmailInputModal from './components/modals/email-input-modal.vue';
import WeightInputModal from './components/modals/weight-input-modal.vue';
Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_KEY,
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
  appVersion: process.env.VUE_APP_VERSION,
});

// ES module-style import
export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  components: {
    ConfirmationModal,
    EndWorkoutModal,
    TipsModal,
    VideoPreviewModal,
    LogoutModal,
    HeightInputModal,
    BirthdayInputModal,
    NameInputModal,
    EmailInputModal,
    WeightInputModal,
  },
  mounted() {
    console.log(process.env.VUE_APP_ORG_ID);
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    if (process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878') {
      link.href = 'https://res.cloudinary.com/menud/image/upload/v1646433564/Erin%20-%20New%20landing%20page/black_2.png';
    } else {
      link.href = 'https://org-5f10adb325bfc2a6e1f9a1cf.s3.amazonaws.com/favicon.ico';
    }
  },
};
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullpath" />
    <VideoPreviewModal />
    <ConfirmationModal />
    <TipsModal />
    <EndWorkoutModal />
    <LogoutModal />
    <HeightInputModal />
    <BirthdayInputModal />
    <NameInputModal />
    <EmailInputModal />
    <WeightInputModal />
  </div>
</template>
